import axios, { AxiosPromise, Canceler, CancelTokenStatic } from 'axios';
import { IDepartment } from '../../../@types/model/masterData/department/department';
import { IDepartmentUpsert } from '../../../@types/model/masterData/department/departmentUpsert';

export default class DepartmentHttpService {
    private static readonly CancelToken : CancelTokenStatic = axios.CancelToken;
    /**
     * Allows you to cancel list request
     */
    public static cancelGetList ?: Canceler;

    public static getList(departmentIds : Array<number> | null) : AxiosPromise<Array<IDepartment>> {
        if (this.cancelGetList) {
            this.cancelGetList('GET Canceled');
            this.cancelGetList = undefined;
        }

        return axios.get(`${API_URL}/v1/MasterData/Department/GetList`, {
            params: {
                departmentIds
            },
            paramsSerializer: {
                indexes: null
            },
            cancelToken: new this.CancelToken((c) => {
                this.cancelGetList = c;
            }),
        });
    }

    public static upsert = (upsert : IDepartmentUpsert, type : 'Add' | 'Edit') : AxiosPromise<IDepartment> => {
        return axios.post(`${API_URL}/v1/MasterData/Department/${type}`, upsert);
    }

    public static delete = (departmentId : number) : AxiosPromise<IDepartment> => {
        return axios.delete(`${API_URL}/v1/MasterData/Department/Delete`, {
            params: { departmentId },
        });
    }
}